import { render } from "./archiveModal.vue?vue&type=template&id=cbd8c3d8&scoped=true&ts=true"
import script from "./archiveModal.vue?vue&type=script&lang=ts"
export * from "./archiveModal.vue?vue&type=script&lang=ts"

import "./archiveModal.vue?vue&type=style&index=0&id=cbd8c3d8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbd8c3d8"]])

export default __exports__